import React, { useEffect, useState } from "react";
import SelectLabels from "../../components/SelectLabels";
import SalesChartSummary from "../../components/SalesChartSummary";
import { useMutation } from "@tanstack/react-query";
import { createData } from "../../utility/managerApi";

function SalesSummary() {
  const [timeRange, setTimeRange] = useState(0);
  const [newPeriod, setNewPeriod] = useState({ data_filter: "7days" });
  const [dataset, setDataset] = useState();
  const period = [
    { id: 0, key: "7days", time: "One Week" },
    { id: 1, key: "30days", time: "One Month" },
    { id: 2, key: "12months", time: "One Year" },
  ];

  const defaultNum = 0;

  useEffect(() => {
    const selected = period[timeRange];
    if (selected) {
      setNewPeriod(selected.key);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeRange]);

  const chartData = useMutation({
    mutationFn: (newPeriod) =>
      createData(
        `dashboard/sales-summary?date_filter=${newPeriod}`,
        null,
        true
      ),
  });
  const handleChange = (value) => {
    setTimeRange(value);
  };
  useEffect(() => {
    chartData.mutate(newPeriod);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newPeriod]);

  useEffect(() => {
    setDataset(chartData?.data);
  }, [chartData]);

  const labels = dataset?.data?.labels || [];
  const datasets = dataset?.data?.datasets || [];

  const newChartData = {
    labels: labels,
    datasets: datasets.map((dataset, index) => ({
      label: dataset.label,
      data: dataset.data,
      backgroundColor: dataset.backgroundColor,
      borderColor: dataset.borderColor || "rgba(0, 0, 0, 0.1)",
      borderWidth: dataset.borderWidth || 1,
      yAxisID: `y-axis-${index}`, // Assign a unique y-axis ID to each dataset
    })),
  };

  return (
    <div className="flex flex-col bg-white rounded-lg gap-6 p-4">
      <div className="flex justify-between  items-center ">
        <h3 className="text-2xl font-medium ">Sales Summary</h3>

        {/* Drop down below */}
        <div>
          <SelectLabels
            valueKey="id"
            labelKey="time"
            text="Select a period"
            categoryData={period}
            onSelectChange={handleChange}
            previousValue={defaultNum}
          />
        </div>
      </div>

      {/* Chart will be added here */}

      <SalesChartSummary dataset={newChartData} datasets={datasets} />
    </div>
  );
}

export default SalesSummary;
